// SevenPass paths and constants

// 7pass credentials
export const defaultClientId = '586f93d4b975ca66bd09fe59';


// 7pass Paths
export const defaultSevenPassOAuthAddress = 'https://sso.7pass.de'; // IF PRODUCTION

export const sevenPassScript = 'https://assets.7pass.de/sdk/js/all.min.js';

// TVsmiles server
export const tvsAddressDefault = 'https://labs.tvsmiles.tv'; // Shouldn't be used

// name of UUID in the device's localStorage
export const localStorageUUIDFieldName = 'TVSMILES_UUID';


export const registrationAddress = 'Redirect_7PassRegistration_address';
export const registrationAddressChallengeId = 'Redirect_7passRegistration_challengeId';


// WEBPACK FOOTER //
// ./src/campaign/challenges/sevenPassLogin/config.js